export default class Configuration {
  static get CONFIG () {
    return {
      API_LANG_URL: '$VUE_APP_API_LANG_URL',
      API_AUTHENTICATION_URL: '$VUE_APP_API_AUTHENTICATION_URL',
      API_FRAME_URL: '$VUE_APP_API_FRAME_URL',
      API_SERVICES_URL: '$VUE_APP_API_SERVICES_URL',
      API_MULTIMEDIA_URL: '$VUE_APP_API_MULTIMEDIA_URL',
      API_HTML_ABSOLUTE_PATH: '$VUE_APP_API_HTML_ABSOLUTE_PATH',
      API_GOOGLE_MAPS_KEY: '$VUE_APP_API_GOOGLE_MAPS_KEY',
      API_GOOGLE_TRANSLATE_KEY: '$VUE_APP_API_GOOGLE_TRANSLATE_KEY',
      API_GOOGLE_TRANSLATE_URL: '$VUE_APP_API_GOOGLE_TRANSLATE_URL',
      API_OPENAI_TRANSLATE_KEY: '$VUE_APP_API_OPENAI_TRANSLATE_KEY',
      API_OPENAI_TRANSLATE_URL: '$VUE_APP_API_OPENAI_TRANSLATE_URL',
      API_TINYMCETMD_ROOT_PATH: '$VUE_APP_API_TINYMCETMD_ROOT_PATH',
      API_TINYMCETMD_SKIN_PATH: '$VUE_APP_API_TINYMCETMD_SKIN_PATH',
      API_TINYMCETMD_LANG_PATH: '$VUE_APP_API_TINYMCETMD_LANG_PATH',
      NORMAL_LOGIN: '$VUE_APP_NORMAL_LOGIN',
      USER_ADMIN: '$VUE_APP_USER_ADMIN',
      PSWD_ADMIN: '$VUE_APP_PSWD_ADMIN',
      APP_DEFAULT_LANGUAGE: '$VUE_APP_APP_DEFAULT_LANGUAGE',
      APP_NEW_ASSETS_MANAGER: '$VUE_APP_APP_NEW_ASSETS_MANAGER',
      REALM_URL: '$VUE_APP_REALM_URL',
      REALM_REALM: '$VUE_APP_REALM_REALM',
      REALM_GRANT_TYPE: '$VUE_APP_REALM_GRANT_TYPE',
      REALM_CLIENT_ID: '$VUE_APP_REALM_CLIENT_ID',
      REALM_REDIRECT_URI: '$VUE_APP_REALM_REDIRECT_URI',
      REALM_OPEN_ID: '$VUE_APP_REALM_OPEN_ID'
    }
  }

  static value (name) {
    if (!(name in this.CONFIG)) {
      console.error(`Configuration: There is no key named "${name}"`)
      return
    }

    const value = this.CONFIG[name]

    if (!value) {
      console.error(`Configuration: Value for "${name}" is not defined`)
      return
    }

    if (value.startsWith('$VUE_APP_')) {
      // value was not replaced, it seems we are in development.
      // Remove $VUE_APP_ and get current value from process.env
      const envName = value.substr(9)
      const envValue = process.env[envName]
      if (envValue !== undefined) {
        return envValue
      } else {
        console.error(`Configuration: Environment variable "${envName}" is not defined`)
      }
    } else {
      // value was already replaced, it seems we are in production.
      return value
    }
  }
}
